import { render, staticRenderFns } from "./ListSeguroiprevnumeroparcelaPage.vue?vue&type=template&id=b14b104a&"
import script from "./ListSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js&"
export * from "./ListSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports